<template>
  <div
    class="flex items-start space-x-2 text-red-500 bg-red-100 border border-red-300 rounded"
  >
    <svg-alert />
    <span class="text-sm">
      <slot></slot>
    </span>
  </div>
</template>

<script>
import SvgAlert from "@/components/Svg/SvgAlert";

export default {
  components: { SvgAlert },
};
</script>
